import { render } from "./accordian_rolling.vue?vue&type=template&id=49ec0b7c&scoped=true"
import script from "./accordian_rolling.vue?vue&type=script&lang=js"
export * from "./accordian_rolling.vue?vue&type=script&lang=js"

import "./accordian_rolling.vue?vue&type=style&index=0&id=49ec0b7c&scoped=true&lang=css"

import exportComponent from "/Users/farhanlatif/Code/admin-dashboard/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ec0b7c"]])

export default __exports__